
export default {
    name: 'blogger-ranking-loading-container',
}
